const namespace = "gameServerConnectionError";

export const DESCRIPTION = `${namespace}.description`;
export const RETRY_BUTTON = `${namespace}.retryButton`;
export const CLOSE = `${namespace}.close`;
